import React from 'react'
import { RetentionResource } from '../../../models/RetentionPolicy'

export const RetentionPolicyDocumentResourceBody: React.FC<{ retentionResource: RetentionResource }> = () => {
  return <></>
}
